module.exports = __webpack_public_path__ + "static/iwabuchiyamorisha.1d1b45bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/iwabuchiyamorisha.png
// module id = 503
// module chunks = 35783957827783